import {
  ProgramMasterApiDataInter,
  ProgramMasterApiParsedRes,
  ProgramMasterApiResponse,
  QuarterApiParsedResponse,
  QuarterMasterApiResponse,
} from "../types/header";

const headerParser: any = {};

headerParser.programWithYears = (
  res: ProgramMasterApiResponse
): ProgramMasterApiParsedRes => {
  let data: ProgramMasterApiDataInter[] = [];

  if (Array.isArray(res.data) && res.data.length > 0) {
    data = res.data;
  }
  const programs = data.map((program) => ({
    label: program.programMasterName,
    value: program.programMasterId,
  }));

  // const years = data.flatMap((program) => {
  //     return program.ProgramYear.map((y) => ({
  //         label: y.year,
  //         value: y.ProgramYearId,
  //     }));
  // });

  return { programs };
};

headerParser.quarter = (
  res: QuarterMasterApiResponse
): QuarterApiParsedResponse[] => {
  let data: any = [];
  if (Array.isArray(res.data) && res.data.length > 0) {
    data = res.data;
  }

  const quarters = data.map((quater: any) => ({
    ProgramYearId: quater.ProgramYearId,
    year: quater.year,
    quarterMaster: quater.quarterMaster,
    isActive: quater.isActive,
    createdAt: quater.createdAt,
    updatedAt: quater.updatedAt,
    publishedAt: quater.publishedAt,
  }));

  return quarters;
};

export default headerParser;
